import isEmpty from 'lodash/isEmpty';
import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';
import { getLocalDateOnly } from '../../utils/local_date';

export function deleteTaxCode(app, params) {
  const { id } = params;
  return common.deleteDoc(app, { id: id , docType: DocType.TAX_CODE});
}

export function saveTaxCode(app, dataToSave) {
  const { user={}, data } = dataToSave;
  let taxCodeData = {
    doc_type: DocType.TAX_CODE,
    available_from: getLocalDateOnly(data.available_from),
    available_to: getLocalDateOnly(data.available_to),
    tax_group_id:  data.tax_group_id,
    tax_type_id: data.tax_type_id,
    country_id:  data.country_id,
    state:  util.toStringText(data.state),
    county: util.toStringText(data.county),
    district: util.toStringText(data.district),
    city: util.toStringText(data.city),
    zipcode: util.toStringText(data.zipcode),
    rate: (data.rate===null || data.rate==="") ? 0 : parseFloat(data.rate),
    amount_from: util.toDecimal(data.amount_from),
    amount_to: util.toDecimal(data.amount_to),
    active:true,
    system_defined: false,
    sale_order: util.toBoolean(data.sale_order), 
    purchase_order: util.toBoolean(data.purchase_order)
  };
  return common.saveDoc(app, {
    source: data,
    doc: taxCodeData,
    user,
  });
}

export function fetchTaxCodeById(app, params) {
  const { id } = params;
  const docType = DocType.TAX_CODE;
  return common.getDoc(app, { id, docType });
}


export function getApplicableTaxByTaxGroupId(app, taxGroupId) {
  if (!taxGroupId) return null;

  const params = {
    active: true,
    sale_order: true,
    tax_group: [taxGroupId]
  };
  
  return common.queryDocs(app, DocType.TAX_CODE, params)
    .then(result => result.data);
}

export function calculateTotalTaxRate(taxes) {
  return (taxes || []).reduce((total, tax = {}) => {
    const { rate } = tax;
    const taxRate = !rate || isEmpty(rate) || isNaN(rate) ? 0 : rate;
    return total + (Number(taxRate) / 100.0);
  }, 0)
}


export function getTotalTaxRate(app, taxGroupId) {
  if (!taxGroupId) return null;

  const params = {
    active: true,
    sale_order: true,
    tax_group: [taxGroupId]
  };
  
  return common.queryDocs(app, 'tax_code/total_tax_rate', params);
} 